import { isNullOrUndefined } from '@app/util/util';
import { ReservationFlight, ReservationPriceChanges } from '@user-history/entities/history-booking-detail';
import { ReservationStatus } from '@user-history/entities/reservation-status';
import { ReservationItems } from '@user-history/entities/user-history-item';
import { isCancelledReservationByStatus, isConfirmReservationByStatus } from '@ux/mappers/reservation-status.mapper';
import { AVIANCA_AIR_CODE } from '@shared/luggage/constants/airline-code.constants';

export function isExpiredOrProcessing(status: ReservationStatus): boolean {
  return status === ReservationStatus.Expired || status === ReservationStatus.Processing || 
    status === ReservationStatus.OnHold || isCancelledReservationByStatus(status);
}

export function getReservationExpiredOrProcessing(
  status: ReservationStatus, reservations: ReservationFlight[]
): ReservationFlight[] {
  if (status === ReservationStatus.Expired) {
    return reservations;
  } else {
    if (status === ReservationStatus.Processing || status === ReservationStatus.OnHold) {
      return reservations.filter(_reservation => _reservation.Status === ReservationStatus.Processing || 
        _reservation.Status === ReservationStatus.Confirm || _reservation.Status === ReservationStatus.OnHold);
    } else {
      if (isCancelledReservationByStatus(status)) {
        return reservations.filter(_reservation => !!isCancelledReservationByStatus(_reservation.Status));
      } else {
        return reservations;
      }
    }
  }
}

export function getDefaultFlightReservations(reservations: ReservationFlight[] | ReservationItems[],
  isReservationItem: boolean = false): ReservationFlight[] | ReservationItems[] {
  return reservations.length ? (
    reservations.length > 1 ? getConfirmReservation(reservations, isReservationItem) :
      (reservations.length === 1 ? reservations : [])
  ) : [];
}

export function getPricesOverChanges(reservations: ReservationFlight[]): ReservationPriceChanges[] {
  const priceChanges: ReservationPriceChanges[] = [];
  reservations
    .filter((reservation: ReservationFlight) => reservation.Status === ReservationStatus.Exchanged)
    .map((reservation: ReservationFlight) => {
      const { Price, Id } = reservation;
      const { Amount, Fees, DiscountAmount, CommissionAmount, CurrencyCode, Surcharges,
        Total, TotalFareCalculated, DiscountPercentageCalculated, PenaltyAmount, Taxes } = Price;
      priceChanges.push({
        Amount, Fees, DiscountAmount, CommissionAmount, CurrencyCode, Surcharges, Id,
        Total, TotalFareCalculated, DiscountPercentageCalculated, PenaltyAmount, Taxes
      });
    });
  return priceChanges;
}

export function mapperReferenceCode(airlineCode: string, referenceCode: string): string {
  const referenceCodeReplace = `${AVIANCA_AIR_CODE}_`;
  return airlineCode === AVIANCA_AIR_CODE ? referenceCode?.replace(referenceCodeReplace, '') :
    referenceCode;
}

function getConfirmReservation(reservations: ReservationFlight[] | ReservationItems[], isReservationItem: boolean):
  ReservationFlight[] | ReservationItems[] {
  const defaultReturn = isReservationItem ? [] as ReservationItems[] : [] as ReservationFlight[];
  const _reservations = Object.assign([], reservations);
  const confirmedItems = _reservations.filter(item =>
    isReservationItem ?
      isConfirmReservationByStatus(item.ReservationStatus) :
      (isConfirmReservationByStatus(item.Status) || !isNullOrUndefined(status))
  );
  return confirmedItems.length > 0 ? confirmedItems : defaultReturn;
}
